document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("wishlist-items");

  updateWishlistCount();
  markWishlistButtonsOnCards();

  if (!container) return;

  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  if (!wishlist.length) return;

  container.innerHTML = "";

  wishlist.forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        container.insertAdjacentHTML("beforeend", `
          <div class="wishlist-item">

            <button
              type="button"
              class="remove-wishlist"
              data-handle="${handle}"
              aria-label="Remove from wishlist">
              x
            </button>

            <a href="${product.url}">
              <img src="${product.featured_image}" alt="${product.title}">
              <h3>${product.title}</h3>
              <p class="wishlist-item__price">
                ${formatMoney(product.price)}
              </p>
            </a>
          </div>
        `);
      });
  });
});

document.addEventListener("click", e => {
  if (!e.target.classList.contains("remove-wishlist")) return;

  const handle = e.target.dataset.handle;
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  wishlist = wishlist.filter(h => h !== handle);
  localStorage.setItem("wishlist", JSON.stringify(wishlist));

  e.target.closest(".wishlist-item").remove();

  updateWishlistCount();
});


document.addEventListener("click", e => {
  const btn = e.target.closest(".add-to-wishlist");
  if (!btn) return;

  e.preventDefault();

  const handle = btn.dataset.handle;
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  if (!wishlist.includes(handle)) {
    wishlist.push(handle);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    showWishlistToast("Added to Wishlist");
    btn.classList.add("is-active");
    updateWishlistCount();
  } else {
    wishlist = wishlist.filter(h => h !== handle);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    showWishlistToast("Removed from Wishlist");
    btn.classList.remove("is-active");
    updateWishlistCount();
  }
});

function updateWishlistCount() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  document.querySelectorAll('.onhow-wishlist-count').forEach(el => {
    el.textContent = wishlist.length;

    if (wishlist.length > 0) {
      el.classList.add('is-visible');
    } else {
      el.classList.remove('is-visible');
    }
  });
}

function showWishlistToast(message) {
  const toast = document.getElementById('wishlist-toast');
  if (!toast) return;

  toast.textContent = message;
  toast.classList.add('show');

  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => {
    toast.classList.remove('show');
  }, 2500);
}

function markWishlistButtonsOnCards() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  wishlist.forEach(handle => {
    document.querySelectorAll(`.add-to-wishlist[data-handle="${handle}"]`).forEach(btn => {
      btn.classList.add('is-active');
    });
  });
}


